/* eslint-disable no-console */
require('videojs-contrib-ads');
require('videojs-ima');
import videoAnalytics from '../modules/video-player-analytics';
import $ from 'jquery';
import _ from 'lodash';

class VideoInit {
    constructor() {
        // Set Default Player Options Setup:
        this.options = {
            'autoplay': false,
            'controls': true,
            'height': window.innerHeight,
            'preload': 'auto',
            'width': window.innerWidth
        };
        // Player Initialize:
        this.player = videojs('video-player-embed', this.options);
        window.player = this.player;
        // Other Instance Vars:
        this.video = document.getElementById('video-player-embed_html5_api');
        this.extension = this.video.canPlayType('video/webm') ? 'webm' : 'mp4';
        this.resolution = window.innerWidth > 700 ? '720' : '480';
        this.playlist = [];
        this.playlistCounter = 0;
        this.adTagUrl = '';
        this.ads = true;
    }

    init() {
        // Set Ad Options
        var options = {
            id: 'video-player-embed',
            adTagUrl: this.buildAdTagUrl()
        };

        // Initialize Ads
        this.player.ima(options, () => {
            this.player.ima.start();
        });
        this.player.ima.requestAds();
        this.player.ima.setShowCountdown(true);

        // Start Player on Watch Pages
        if (window.parent.document.querySelector('.fc-header.-watch')) {
            this.player.play();
        }

        videoAnalytics.on({
            player: this.player
        });

        // Initialize Playlist
        this.playlistInit(
            () => {
                this.player.on('ended', () => {
                    // Update URL and title of video
                    $('.vjs-video-title').html(this.playlist[this.playlistCounter].title);
                    this.player.ima.setContent(this.playlist[this.playlistCounter].url, null, true);
                    this.player.ima.requestAds();
                    this.player.ima.setShowCountdown(true);
                    this.playlistCounter++;
                    videoAnalytics.on({
                        player: this.player,
                        reset: true
                    });
                    this.player.ima.start();


                });
            }
        );
    }

    // Ad Tag Setter
    buildAdTagUrl() {
        // Base:
        var adUrl = 'https://pubads.g.doubleclick.net/gampad/ads?' +
        'sz=640x360' +
        '&impl=s' +
        '&gdfp_req=1' +
        '&env=vp' +
        '&output=vast' +
        '&unviewed_position_start=1' +
        '&vad_type=linear' +
        '&vpos=preroll' +
        // Ad Ops Params:
        '&iu=' + this.getParam('zone') + '/preroll' +
        '&correlator=' + Date.now() +
        // Custom Params:
        // TESTING:
        // '&cust_params=cms%3Ddfp_video_test';
        // PRODUCTION:
        '&cust_params=video_tags%3D' + window.DFPtags;
        return adUrl;
    }

    sanitizePlaylistItems(nid, playList) {
        // Remove current nid from the playlist
        let sanitizedList = [];
        let matchedIndex = null;
        const nidInt = parseInt(nid, 10);
        $.each(playList, function (index, item) {
            if (item.nid === nidInt) {
                matchedIndex = index;
                return false;
            }
        });

        if (matchedIndex === null) {
            sanitizedList = playList;
        } else {
            // Then split the playlist to [Before the matched ID] and [After the matched ID]
            /*
                [a,b,c,d,e,f,g,h]  <---- item e matches current video id, then the array becomes
                [f,g,h,a,b,c,d]

            */
            let playListLength = playList.length;

            // Clone these variable to prep for splicing
            let playListCopyForFirstHalf = playList.slice(0), playListCopyForSecondHalf = playList.slice(0);

            // Remove anything up to the matching nid
            let firstHalf = playListCopyForFirstHalf.splice(0, matchedIndex);

            //Remove first few elements up to the matched Index item
            let secondHalf = playListCopyForSecondHalf.splice(++matchedIndex, playListLength - matchedIndex);
            sanitizedList = secondHalf.concat(firstHalf);
        }

        return sanitizedList;
    }

    // Get Vars From Containining Window
    getParam(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0] === variable) {
                var param = decodeURIComponent(pair[1]);
                return param.replace(/\"|\'/, "");
            }
        }
        return false;
    }

    // 1. Check to see if the series is a custom content, using this api: api/v3/modules/check_is_custom?tag=NAME_OF_SUPERTAG
    // 2. If it is a custom, call getPlaylistURLFromSeries() else call getPlaylistURLFromQueue()
    // Example of a NON-Custom Video: http://fastcompany.local:8880/embed/260894d0f167f?watermark=0&autoplay=1&nid=3055097&poster=full&rel=1&kind=watch
    // Example of a Custom Video: http://fastcompany.local:8880/embed/aa964060fe030?watermark=0&autoplay=1&nid=3057622poster=full&rel=1&kind=watch
    playlistInit(fn) {
        const adTags = window.DFPtags || null;
        let supertag = null;

        if (adTags) {
            // Sanitize it by replacing _ with -
            supertag = adTags.split(',')[0].replace(/_/ig, '-');
        }

        if (supertag) {
            $.get('/api/v3/modules/check_is_custom?tag=' + supertag, (result) => {
                if (result && result.status === 200 && result.isCustom === true) {
                    // This is a custom content, call API to get playlist from that series
                    this.getPlaylistURLFromSeries(supertag, fn);
                } else {
                    // Not custom content, retrieve playlist from regular queue
                    this.getPlaylistURLFromQueue(fn);
                }
            });
        } else {
            // No supertag identified, just get regular queue as playlist
            this.getPlaylistURLFromQueue();
        }
    }

    getPlaylistURLFromSeries(supertag, fn) {
        const nid = this.getParam('nid');

        $.get('/api/v3/modules/video_series_playlist?tag=' + supertag, (result) => {
            if (result && result.status === 200 && result.videos) {
                let sanitizedSponsorPlaylist = [];
                let playlistUrls = [];
                sanitizedSponsorPlaylist = this.sanitizePlaylistItems(nid, result.videos);

                _.each(sanitizedSponsorPlaylist, (item) => {
                    playlistUrls.push({
                        url: `//api.twistage.com/videos/${item.videoID}/formats/${this.extension}_${this.resolution}/play.${this.extension}`,
                        title: item.title
                    });
                });
                this.playlist = playlistUrls;
                fn();
            }
        });
    }

    // AJAX Call to Populate Playlist
    getPlaylistURLFromQueue(fn) {
        var request = new XMLHttpRequest();
        var playlist = [];
        // New request
        request.open('GET', '/api/v3/modules/video-playlist', true);
        // Request processing
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                var data = JSON.parse(request.responseText).response;
                var i = 0;
                const nid = this.getParam('nid');
                var sanitizedSponsorPlaylist = this.sanitizePlaylistItems(nid, data);

                for (i; i < sanitizedSponsorPlaylist.length; i++) {
                    var datum = sanitizedSponsorPlaylist[i];
                    var urlObj = {
                        url: '//api.twistage.com/videos/' + datum.videoID + '/formats/' + this.extension + '_' + this.resolution + '/play.' + this.extension,
                        title: datum.title
                    };
                    playlist.push(urlObj);
                }
                this.playlist = playlist;
                return fn();
            }
            console.error('We reached our target server, but it returned an error');
        }.bind(this);
        // Request error handling
        request.onerror = function () {
            console.error('There was a connection error of some sort');
        };
        // Request initialized
        request.send();
    }

    // Set Listeners
    on() {
        window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
}

export default new VideoInit();
